var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "vs-row",
    {
      attrs: { "vs-type": "flex", "vs-justify": "space-between", "vs-w": "12" }
    },
    [
      _c(
        "vs-col",
        {
          staticClass: "vs-pagination--mb",
          attrs: {
            "vs-type": "flex",
            "vs-justify": "flex-start",
            "vs-align": "center",
            "vs-lg": "6",
            "vs-sm": "12",
            "vs-xs": "12"
          }
        },
        [
          _vm.description
            ? _c("div", [
                _c("span", { staticStyle: { "margin-right": "5px" } }, [
                  _vm._v(
                    " " +
                      _vm._s(_vm.descriptionTitle) +
                      ": " +
                      _vm._s(_vm.minRows) +
                      " - " +
                      _vm._s(_vm.maxRows) +
                      " " +
                      _vm._s(_vm.descriptionConnector) +
                      " " +
                      _vm._s(_vm.sizeArray) +
                      " | " +
                      _vm._s(_vm.descriptionBody) +
                      ": "
                  )
                ]),
                _c(
                  "ul",
                  { staticClass: "vs-pagination--array" },
                  _vm._l(_vm.descriptionItems, function(row, index) {
                    return _c("li", { key: index }, [
                      _c(
                        "span",
                        {
                          class: [
                            "vs-description-" + _vm.color,
                            { "vs-pagination--bold": index == _vm.indexRows }
                          ],
                          style: _vm.styleDescription,
                          on: {
                            click: function($event) {
                              return _vm.changeRowMaxItems(index)
                            }
                          }
                        },
                        [_vm._v(" " + _vm._s(row) + " ")]
                      ),
                      index !== _vm.descriptionItems.length - 1
                        ? _c("span", [_vm._v(" , ")])
                        : _vm._e()
                    ])
                  }),
                  0
                )
              ])
            : _vm._e()
        ]
      ),
      _c(
        "vs-col",
        {
          staticClass: "vs-pagination--mb",
          attrs: {
            "vs-type": "flex",
            "vs-justify": "flex-end",
            "vs-align": "center",
            "vs-lg": "6",
            "vs-sm": "12",
            "vs-xs": "12"
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "con-vs-pagination",
              class: ["vs-pagination-" + _vm.color],
              style: _vm.stylePagination
            },
            [
              _c("nav", { staticClass: "vs-pagination--nav" }, [
                _c(
                  "button",
                  {
                    staticClass:
                      "vs-pagination--buttons btn-prev-pagination\n          vs-pagination--button-prev rounded-circle",
                    class: { disabled: _vm.current <= 1 ? "disabled" : null },
                    attrs: { disabled: _vm.current === 1 },
                    on: { click: _vm.prevPage }
                  },
                  [
                    _c("vs-icon", {
                      attrs: {
                        "icon-pack": _vm.iconPack,
                        icon: _vm.prevIcon ? _vm.prevIcon : _vm.defaultPrevIcon
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "ul",
                  { staticClass: "vs-pagination--ul mb-0" },
                  _vm._l(_vm.pages, function(page, index) {
                    return _c(
                      "li",
                      {
                        key: index,
                        staticClass: "item-pagination vs-pagination--li",
                        class: { "is-current": page === _vm.current },
                        on: {
                          click: function($event) {
                            return _vm.goTo(page)
                          }
                        }
                      },
                      [
                        _c("span", [_vm._v(" " + _vm._s(page) + " ")]),
                        _c("div", { staticClass: "effect" })
                      ]
                    )
                  }),
                  0
                ),
                _c(
                  "button",
                  {
                    staticClass:
                      "vs-pagination--buttons btn-next-pagination\n           vs-pagination--button-next rounded-circle",
                    class: {
                      disabled: _vm.current === _vm.total ? "disabled" : null
                    },
                    attrs: { disabled: _vm.current === _vm.total },
                    on: { click: _vm.nextPage }
                  },
                  [
                    _c("vs-icon", {
                      attrs: {
                        "icon-pack": _vm.iconPack,
                        icon: _vm.nextIcon ? _vm.nextIcon : _vm.defaultNextIcon
                      }
                    })
                  ],
                  1
                )
              ])
            ]
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }